/**
 * Umožňuje zachytávání chyb a jejich zpracování. Může je i prezentovat uživateli.
 */
export interface IErrorHandler {
    /**
     * Zachytí a zpracuje chybu.
     * @param error Cokoli, co může být throwable, což je prakticky cokoliv. Je však preferováno, aby šlo o Error nebo jeho potomky.
     */
    handleError(error: unknown): void;
    /**
     * Spustí zachytávání chyb z asynchronních procesů, které nebyly jinde zachycené.
     */
    activateAsyncGlobalErrorHandler(): void;
}

export class IErrorHandler {
    protected static _properties: (keyof IErrorHandler)[] = [];

    protected static _methods: (keyof IErrorHandler)[] = [ "handleError" ];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
